export default function notContainsValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      notContains: '='
    },
    link(scope, elem, attrs, ngModel) {
      scope.$watch(
        () => {
          const isValid = doesNotContain(ngModel.$modelValue, scope.notContains);
          return isValid;
        },
        (currentValue) => {
          ngModel.$setValidity('validWhenNotContains', currentValue);
        }
      );

      ngModel.$parsers.unshift((value) => {
        if (ngModel.$pristine) {
          return value;
        }
        if (!angular.isString(value)) {
          return value;
        }
        value = value.trim();
        if (value === '') {
          return value;
        }
        if (value.length < 8) {
          return value;
        }
        const isValid = doesNotContain(value, scope.notContains);

        ngModel.$setValidity('notContains', isValid);
        return value;
      });
    }
  };

  function doesNotContain(value, notContains) {
    if (value && angular.isString(value) && notContains && angular.isString(notContains)) {
      return !value.includes(notContains) && !notContains.includes(value);
    }
    return true;
  }
}
